var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.875 18a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m1 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m14.25 0a.5.5 0 0 0-.5-.5H8.875a.5.5 0 0 0 0 1h11.75a.5.5 0 0 0 .5-.5m-15.25-6a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m1 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m14.25 0a.5.5 0 0 0-.5-.5H8.875a.5.5 0 0 0 0 1h11.75a.5.5 0 0 0 .5-.5M5.875 6a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0m1 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m13.75.5H8.875a.5.5 0 0 1 0-1h11.75a.5.5 0 0 1 0 1",
    clipRule: "evenodd"
  })));
};
export default SvgList;